<div class="app-loading-overlay" *ngIf="state.visible" role="status" aria-live="polite">
    <div class="app-loading-card">
        <div class="app-loading-spinner" aria-hidden="true"></div>
        <p>{{ state.message }}</p>
    </div>
</div>
